import React from "react";
import { FaPlus, FaMinus } from "react-icons/fa6";

const Card = ({ question, answer, isOpen, setIsOpen }) => {
  const { text, bulletPoints } = answer;
  const handleToggle = () => {
    setIsOpen();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleToggle();
    }
  };

  return (
    <div className={`faq ${isOpen ? "bgRed is-open" : "bgWhite"}`}>
      <div
        className="faq_qu"
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
      >
        <span>
          {question}
          <span className={`faq_toggle_icon ${isOpen ? "open" : ""}`}>
            {isOpen ? <FaMinus /> : <FaPlus />}
          </span>
        </span>
        <div className="faq_ans">
          <div className="faq_ans_inner">
            <p>{text}</p>
            {bulletPoints && bulletPoints.length > 0 && (
              <ul>
                {bulletPoints.map((list, index) => (
                  <li key={index} className="ml-3">
                    {list}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
